module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Podcast"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "columns is-centered"
  }, [_c('div', {
    staticClass: "column is-12 content"
  }, [_c('h1', {}, [_c('a', {
    attrs: {
      "href": "https://cowork.progressbar.sk/podcast"
    }
  }, [_vm._v("Prvý Pokusný Podcast Progressbaru - PPPP - ⛓ links")]), _c('br'), _c('br'), _vm._v("\n      💬 "), _c('a', {
    attrs: {
      "href": "https://t.me/progressbarpodcast"
    }
  }, [_vm._v("Telegram Channel")]), _c('br'), _vm._v("\n      🎥 "), _c('a', {
    attrs: {
      "href": "https://www.youtube.com/playlist?list=PLfCtn83lMV3CzkXkGdkdUnNZvD5c4hBbC"
    }
  }, [_vm._v("Youtube Playlist")]), _c('br'), _vm._v("\n      🎧 "), _c('a', {
    attrs: {
      "href": "https://podcasts.apple.com/us/podcast/id1465903607"
    }
  }, [_vm._v("Apple Podcasts")]), _c('br'), _vm._v("\n      🎧 "), _c('a', {
    attrs: {
      "href": "https://open.spotify.com/show/2arFgMfH8p27iEpwJmFv23"
    }
  }, [_vm._v("Spotify")]), _c('br'), _vm._v("\n      🐬 "), _c('a', {
    attrs: {
      "href": "https://api.substack.com/feed/podcast/10023.rss"
    }
  }, [_vm._v("RSS")]), _c('br'), _vm._v("\n      📧 "), _c('a', {
    attrs: {
      "href": "https://pppp.substack.com/"
    }
  }, [_vm._v("Newsletter")]), _c('br'), _vm._v("\n      🤑 "), _c('router-link', {
    attrs: {
      "to": "/pay"
    }
  }, [_vm._v("Support us")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns is-centered"
  }, [_c('div', {
    staticClass: "column is-12 content"
  }, [_c('iframe', {
    attrs: {
      "height": "600",
      "src": "https://www.youtube.com/embed/videoseries?list=PLfCtn83lMV3CzkXkGdkdUnNZvD5c4hBbC",
      "frameborder": "0",
      "allow": "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
      "allowfullscreen": ""
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51ec59da","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Podcast.vue
// module id = 247
// module chunks = 17